import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function AdminSidebar() {
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    { path: "/admin/dashboard", label: "Dashboard" },
    { path: "/admin/bookings", label: "Bookings" },
    { path: "/admin/users", label: "Users" },
    { path: "/admin/statistics", label: "Statistics" }, // changed duplicate bookings → statistics
    { path: "/admin/therapies", label: "Therapies" },
    { path: "/admin/staff", label: "Staff" },
    { path: "/admin/settings", label: "Settings" },
  ];

  return (
    <aside className="w-72 bg-[#EBE0CF] text-[#0B2A2C] min-h-screen p-6 shadow-xl border-r border-[#d9c9b0] flex flex-col">
      <div className="mb-10">
        <h3 className="text-2xl font-bold text-[#0B2A2C] tracking-tight">
          Admin Panel
        </h3>
        <p className="text-sm text-gray-600 mt-1">Management Console</p>
      </div>

      <nav className="flex-1">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const isActive = currentPath === item.path;
            
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`
                    flex items-center px-4 py-3 rounded-lg text-[15px] font-medium transition-all duration-200
                    ${isActive
                      ? "bg-[#0B2A2C] text-white shadow-sm" 
                      : "text-[#0B2A2C] hover:bg-[#d9c9b0]/40 hover:text-[#0B2A2C]"
                    }
                  `}
                >
                  <span>{item.label}</span>
                  
                  {isActive && (
                    <span className="ml-auto w-2 h-2 rounded-full bg-[#F97316]"></span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Optional footer / version or logout */}
      <div className="mt-auto pt-8 border-t border-[#d9c9b0]/60 text-sm text-gray-600">
        <p>© {new Date().getFullYear()} Admin System</p>
      </div>
    </aside>
  );
}